<script setup lang="ts">
  import type { InputProps } from 'naive-ui'

  const emit = defineEmits<{
    (event: 'search', query: string): void
  }>()

  const input = defineModel<string>({ default: '' })
  const handleSearch = () => {
    emit('search', input.value)
  }

  const inputThemeOverrides: NonNullable<InputProps['themeOverrides']> = {
    border: '1px solid var(--color-border)',
    heightMedium: '40px',
  }
</script>

<template>
  <NInput
    v-model:value="input"
    :placeholder="$t('header_search')"
    class="ml-0.5 rounded-[10px]! bg-transparent"
    :input-props="{
      type: 'search',
      inputmode: 'search',
      enterkeyhint: 'search',
      'aria-label': $t('base_search'),
    }"
    clearable
    :theme-overrides="inputThemeOverrides"
    @keydown.enter="handleSearch"
  >
    <template #prefix>
      <i class="fa-regular fa-magnifying-glass text-icon-hover cursor-pointer" />
    </template>
  </NInput>
</template>
